<template>
  <div>
    <rest-list :payload="fetchEndpoint" ref="rest-list">
      <template>
        <rest-list-column-date
          prop="create_time"
          :title="$t('TaskHistoryList_Field_CreateTime')"
          :width="200"
        />

        <rest-list-column-date
          prop="finish_time"
          :title="$t('Automations_RunHistory_CompletionDate')"
          :width="200"
        />

        <rest-list-column-enum
          prop="status"
          :title="$t('TaskHistoryList_Field_Status')"
          :enum="statusLabel"
          :min-width="150"
        />

        <rest-list-column
          v-if="isDbSource"
          prop="syncMode"
          :sortable="false"
          :filterable="false"
          :title="$t('Imports_Field_SyncMode')"
          :width="130"
        >
          <template slot-scope="scope">
            {{ syncModeLabel(scope.row) }}
          </template>
        </rest-list-column>

        <rest-list-column
          v-if="isDbSource"
          prop="totalRows"
          :sortable="false"
          :filterable="false"
          :title="$t('Automations_RunHistory_RowsFetched')"
          :width="130"
        >
          <template slot-scope="scope">
            {{ formatRows(scope.row) }}
          </template>
        </rest-list-column>

        <rest-list-column
          prop="importTasks"
          :sortable="false"
          :filterable="false"
          :title="
            isDbSource
              ? $t('Automations_RunHistory_Chunks')
              : $t('Automations_RunHistory_Files')
          "
          :width="140"
        >
          <template slot-scope="scope">
            <router-link
              v-if="scope.row.childTaskStats"
              :to="importsTabRoute(scope.row)"
            >
              {{ formatChildTaskStats(scope.row) }}
            </router-link>
            <template v-else>-</template>
          </template>
        </rest-list-column>

        <rest-list-column
          v-if="isDbSource"
          prop="firstDeltaValue"
          :sortable="false"
          :filterable="false"
          :title="$t('Automations_RunHistory_FirstDeltaValue')"
          :width="180"
        >
          <template slot-scope="scope">
            {{ deltaValue(scope.row, 'firstDeltaValue') }}
          </template>
        </rest-list-column>

        <rest-list-column
          v-if="isDbSource"
          prop="lastDeltaValue"
          :sortable="false"
          :filterable="false"
          :title="$t('Automations_RunHistory_LastDeltaValue')"
          :width="180"
        >
          <template slot-scope="scope">
            {{ deltaValue(scope.row, 'lastDeltaValue') }}
          </template>
        </rest-list-column>

        <rest-list-column-actions>
          <template slot-scope="scope">
            <rest-list-action-view :route="rowViewRoute(scope.row)" />
          </template>
        </rest-list-column-actions>
      </template>
    </rest-list>
  </div>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionView from '@/common/components/rest/RestListActionView'
import { taskStatusLabel as statusLabel } from '@/modules/tasks/enum/TaskRecordEnums'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'ImportRunHistorySyncs',

  inject: ['automationData'],

  components: {
    RestList,
    RestListColumn,
    RestListColumnEnum,
    RestListColumnDate,
    RestListColumnActions,
    RestListActionView
  },

  data() {
    return {
      statusLabel
    }
  },

  computed: {
    automationId() {
      return this.$route.query.id
    },

    automation() {
      return this.automationData()
    },

    isDbSource() {
      return (
        this.automation &&
        this.automation.source &&
        this.automation.source.type === 'db'
      )
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'task-histories',
        params: {
          sort: '-id',
          import_automation_id: this.automationId,
          identifier: 'db_import_automation,fs_import_automation',
          expand: 'result,childTaskStats'
        }
      })
    }
  },

  methods: {
    rowViewRoute(row) {
      return projectRoute({
        name: 'TaskHistoryView',
        query: { id: row.id }
      })
    },

    importsTabRoute(row) {
      return projectRoute({
        name: 'AutomationImportRunHistoryTasks',
        query: {
          id: this.automationId,
          filters: JSON.stringify({ sync_task_id: String(row.id) })
        }
      })
    },

    syncModeLabel(row) {
      const mode = row.result && row.result.syncMode
      if (mode === 'delta') return this.$t('Imports_Field_SyncMode_Delta')
      if (mode === 'full') return this.$t('Imports_Field_SyncMode_Full')
      return '-'
    },

    formatRows(row) {
      const total = row.result && row.result.totalRows
      if (total === null || total === undefined) return '-'
      return Number(total).toLocaleString()
    },

    formatChildTaskStats(row) {
      if (!row.childTaskStats) return '-'
      return `${row.childTaskStats.completed} / ${row.childTaskStats.total}`
    },

    deltaValue(row, field) {
      if (!row.result || row.result.syncMode !== 'delta') return '-'
      const val = row.result[field]
      return val !== null && val !== undefined ? String(val) : '-'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/automations/components/ImportRunHistorySyncs.vue